import React, { useRef, useState , useEffect,useMemo} from 'react';
import moment from 'moment';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../irtiza-dynamic-input/irtiza-dynamic-main-inputs';

const BudgetItemInfoAdd = (props) => {
  
  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput};
  
  const [inputProps, setInputProps] = useState({
  
    BudgetItemID:{name: 'BudgetItemID',   value: props.BudgetItemID || '' ,enabled:false},

    BudgetItem:{name: 'BudgetItem',   value: props.BudgetItem || '' },

    BudgetCategory:{
      name:{id:'BudgetCategoryID',value:'BudgetCategory'},
      caption: 'Select Budget Category',
      value: {id: props.BudgetCategoryID || undefined ,value:props.BudgetCategory || ''},
      dataSource: {type:'Route',route:'BudgetCategoryInfo'},
        },


        });
// EXTRA CODE START

// EXTRA CODE END

const handleInputCreated = async (e, name) => {
  console.log(e);
    console.log(`Input ${name} changed to ${e}`);
  };
const handleInputFocus = async (e, name) => {
  
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };
const handleInputChange = async (value, name) => {
  
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleInputBlur = async  (value, name) => {
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
 
  let inputsList = [
    {Input: HiddenComponent ,Props: {...inputProps.BudgetItemID, setInputProps },ColumnSize:0},
    {Input: TextComponent,Props: {...inputProps.BudgetItem,setInputProps },ColumnSize:6},
    {Input: DropdownComponent,Props: {...inputProps.BudgetCategory, setInputProps },ColumnSize:6},
    ];
  return (
    <div onKeyDown={(e)=>e.stopPropagation()}>
      {/* <FirstGridComponent/> */}
      <StructuredGenerate   mainProps={props} title={`Budget Category ${props.isAdd == true ? `Add` : `Edit`}`} Inputs={inputsList}/>
      {/* <pre>{JSON.stringify(inputProps, null, 2)}</pre> This is to display current state for debugging */}
      </div>
  );
}; 

export default BudgetItemInfoAdd;
